import { FC, ReactNode, useContext } from 'react';
import { Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay } from '@chakra-ui/react';
import { get } from 'lodash';
import { TableContext } from '.';
import { CbButton } from '../Buttons/CbButton';
import styles from './TableDrawer.module.css';
export enum TableDrawerName {
  ActivateReward = 'ActivateReward',
  AddPlayers = 'AddPlayers',
  AssignGuides = 'AssignGuides',
  AllFilters = 'AllFilters',
  ArchiveMetrics = 'ArchiveMetrics',
  BulkAddUsersToTeams = 'BulkAddUsersToTeams',
  BulkChestAward = 'BulkChestAward',
  BulkClawbackTokens = 'BulkClawbackTokens',
  BulkTokenAward = 'BulkTokenAward',
  BuyTokens = 'BuyTokens',
  ColumnVisibility = 'ColumnVisibility',
  CreateActivity = 'CreateActivity',
  CreateCompanyReward = 'CreateCompanyReward',
  DeleteTeam = 'DeleteTeam',
  EditActivity = 'EditActivity',
  FulfillReward = 'FulfillReward',
  GiveChest = 'GiveChest',
  GiveRecognition = 'GiveRecognition',
  GiveTokens = 'GiveTokens',
  InvitePlayer = 'InvitePlayer',
  LockPlayer = 'LockPlayer',
  Reinvite = 'Reinvite',
  RestoreMetrics = 'RestoreMetrics',
  UpdateTeamIdentifiers = 'UpdateTeamIdentifiers',
  UpdateType = 'UpdateType',
  UpdateUnit = 'UpdateUnit',
  UpsertMetric = 'UpsertMetric',
  UpsertTeam = 'UpsertTeam',
  VerifyPlayer = 'VerifyPlayer',
  ReverseTransaction = 'ReverseTransaction',
}
const DRAWER_TITLE = {
  ActivateReward: 'Unfulfill Reward',
  AddPlayers: 'Add Learners',
  AllFilters: 'Filters',
  ArchiveMetrics: 'Archive Metrics',
  BulkAddUsersToTeams: 'Add Users To Teams',
  BulkChestAward: 'Give Chests',
  BulkClawbackTokens: 'Clawback Tokens',
  BulkTokenAward: 'Award Tokens',
  BuyTokens: 'Buy Tokens',
  ColumnVisibility: 'Columns',
  DeleteTeam: 'Delete Teams',
  FulfillReward: 'Fulfill Reward',
  GiveChest: 'Give Chest',
  GiveRecognition: 'Give Recognition',
  GiveTokens: 'Give Tokens',
  InvitePlayer: 'Invite',
  LockPlayer: 'Lock Learners',
  Reinvite: 'Reinvite Learners',
  RestoreMetrics: 'Restore Metrics',
  UpdateType: 'Update Metric Type',
  UpdateUnit: 'Update Metric Unit',
  ReverseTransaction: 'Reverse Transaction'
};
const DRAWER_PROPS = {
  AddPlayers: {
    drawerSize: 'lg'
  },
  AssignGuides: {
    drawerSize: 'xl'
  },
  BuyTokens: {
    drawerSize: 'lg'
  },
  GiveChest: {
    drawerSize: 'lg'
  },
  GiveTokens: {
    drawerSize: 'lg'
  },
  UpsertMetric: {
    drawerSize: 'xl'
  },
  UpsertTeam: {
    drawerSize: 'lg'
  },
  ReverseTransaction: {
    drawerSize: 'sm'
  }
};
interface TableDrawerProps {
  children: ReactNode;
  name: TableDrawerName;
}
const OVERLAY_BACKGROUND: string = 'linear-gradient(270deg, rgba(5, 37, 91, 0.35) 51.15%, rgba(5, 37, 91, 0.256147) 89.3%, rgba(5, 37, 91, 0) 100%)';
export const TableDrawer: FC<TableDrawerProps> = ({
  children,
  name
}) => {
  const {
    closeDrawer,
    openDrawerName,
    openDrawerProps
  } = useContext(TableContext);
  const isOpen = openDrawerName === name;
  const drawerSize = get(DRAWER_PROPS, `${openDrawerName}.drawerSize`, 'md');

  /* Sometimes the drawer has a conditional name, so attempt to read it
     from TableContext openDrawerProps, otherwise fallback to the single
     value in the enum above */
  const {
    drawerTitle = DRAWER_TITLE[name]
  } = openDrawerProps;
  return <Drawer isOpen={isOpen} onClose={closeDrawer} size={drawerSize} trapFocus={false} data-sentry-element="Drawer" data-sentry-component="TableDrawer" data-sentry-source-file="TableDrawer.tsx">
      <DrawerOverlay background={OVERLAY_BACKGROUND} data-sentry-element="DrawerOverlay" data-sentry-source-file="TableDrawer.tsx" />
      <DrawerContent boxShadow="0px 3px 15px 2px rgba(0, 0, 0, 0.0900136)" paddingTop={20} paddingX={0} overflowY="scroll" overflowX="scroll" data-sentry-element="DrawerContent" data-sentry-source-file="TableDrawer.tsx">
        <DrawerHeader className={styles.header} paddingX={{
        base: 3,
        md: 12
      }} data-sentry-element="DrawerHeader" data-sentry-source-file="TableDrawer.tsx">
          <span className={styles.title}>{drawerTitle}</span>
          <CbButton onClick={closeDrawer} variant="outline" data-sentry-element="CbButton" data-sentry-source-file="TableDrawer.tsx">
            Close
          </CbButton>
        </DrawerHeader>
        <DrawerBody className={styles.body} marginTop={12} paddingX={{
        base: 3,
        md: 12
      }} data-sentry-element="DrawerBody" data-sentry-source-file="TableDrawer.tsx">
          {isOpen && children}
        </DrawerBody>
      </DrawerContent>
    </Drawer>;
};